import styled from '@emotion/styled'
import tw, { TwStyle } from 'twin.macro'
import { Link } from 'gatsby'
import { X, Check, XCircle, Plus } from 'react-feather'
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@reach/accordion'
import Tooltip from '@reach/tooltip'
import { DialogOverlay, DialogContent, DialogOverlayProps, DialogContentProps } from '@reach/dialog'
import { ListboxPopover } from '@reach/listbox'

// tabdetails
export const DetailsSection = tw.section`w-full mt-8 pr-0 xl:pr-16 flex flex-col`
export const DetailsContainer = styled.div`
	${tw`flex flex-col`}

	> div > div > p:first-of-type {
		${tw`border-l-2 border-light-gray`}
	}
	> div > div > div:first-of-type {
		${tw`border-l-2 border-light-gray`}
	}
	> div > div > p:last-of-type {
		${tw`border-r-2 border-light-gray`}
	}
	> div > div > div:last-of-type {
		${tw`border-r-2 border-light-gray`}
	}
	> div > div > p + div:first-of-type {
		${tw`border-l-0`}
	}

	> div {
		${tw`relative`}
	}
`

export const ProductContainer = styled.div<{ containerStyle: TwStyle }>`
	${tw`flex flex-row`}
	transition: .5s all ease-in-out;
	top: 65px;
	@media (max-width: 1279px) {
		${tw`pr-0!`}
	}
	@media (max-width: 767px) {
		${tw`static! w-full!`}
	}
	${({ containerStyle }) => (containerStyle ? containerStyle : '')}
`
export const ProductTitle = tw.p`w-4/12 lg:w-3/12 xl:w-1/5 flex justify-center items-center py-6 md:py-8 text-2xl md:text-3xl font-display bg-blue-500 text-white border-r-2 border-gray-200 border-b-2`
export const ProductsName = styled.p`
	${tw`relative w-4/12 lg:w-3/12 flex justify-center items-center flex-col px-2 md:px-4 py-12 md:py-8 text-2xl xl:text-3xl font-display bg-blue-500 text-white border-r-2 border-gray-200 border-b-2`}

	> span {
		${tw`text-3xl md:text-4xl xl:text-5xl text-center`}
	}
`
export const RemoveSvg = styled(X)`
	${tw`absolute cursor-pointer bg-gray-800 rounded-full hover:bg-gray-700`};
	padding: 5px;
	right: 15px;
	top: 15px;
`
export const ImageRow = styled.div`
	${tw`flex flex-row`}
	transition: .5s all ease-in-out;
	top: 65px;
	@media (max-width: 1279px) {
		${tw`pr-0!`}
	}
	@media (max-width: 767px) {
		${tw`static! w-full!`}
	}
`
export const BrandImage = tw.div`w-4/12 lg:w-3/12 xl:w-1/5 flex items-center justify-center px-4 border-r-2 border-b-2 border-light-gray`
export const ImageContainer = styled.div`
	${tw`h-screen flex items-center justify-center w-4/12 lg:w-3/12 py-4 border-r-2 border-b-2 border-light-gray`}
	max-height: 160px;

	@media (min-width: 1280px) {
		max-height: 200px;
	}
`
export const ProductImage = styled.picture`
	${tw`h-full`}

	img {
		${tw`h-full`}
		max-height: 160px;

		@media (min-width: 1280px) {
			max-height: 200px;
		}
	}
`

export const SkuContainer = styled(ImageRow)``
export const SkuTitle = tw.p`flex items-center justify-center font-display bg-dark-gray border-r-2 border-b-2 border-light-gray py-8 w-4/12 lg:w-3/12 xl:w-1/5 text-base	 md:text-lg`
export const Sku = tw.p`flex items-center justify-center font-display bg-dark-gray border-r-2 border-b-2 border-light-gray py-8 w-4/12 lg:w-3/12 text-base md:text-lg`

export const LineContainer = styled(ImageRow)``
export const LineTitle = styled(SkuTitle)`
	${tw`bg-white w-4/12 lg:w-3/12 xl:w-1/5 border-r-2 border-b-2 border-light-gray`}
`
export const ProductLineContainer = tw.div`flex items-center justify-center w-4/12 lg:w-3/12 border-r-2 border-b-2 border-light-gray`

export const RrpContainer = styled(ImageRow)``
export const RrpTitle = styled(SkuTitle)``
export const Rrp = styled(Sku)`
	${tw`font-bold`}
`

export const FeatureRow = styled.div`
	${tw`flex flex-row`}
	> div {
		> span {
			${tw`mr-2 relative pr-8 w-full`}
		}
	}
	> p,
	> div:first-of-type,
	> div + p:first-of-type {
		${tw`w-4/12 lg:w-3/12 flex items-center justify-center py-6 px-6 text-center border-r-2 border-light-gray border-b-2 font-display`}
	}
	> div:first-of-type,
	> p:first-of-type {
		${tw`w-4/12 lg:w-3/12 xl:w-1/5`}
	}

	.flexIt {
		${tw`flex flex-col`}

		> span {
			${tw`flex flex-row items-center pr-3 w-full text-left`}
		}
		> span:not(:last-of-type) {
			${tw`mb-4`}
		}
		> span > svg {
			${tw`flex-none mr-3`}
		}
	}
`

export const Acc = styled(Accordion)``
export const AccItem = styled(AccordionItem)`
	${tw`border-r-0!`}
`
export const AccButton = styled(AccordionButton)`
	${tw`flex flex-row relative pl-6 py-6 cursor-pointer overflow-hidden font-display uppercase border-b-2 border-r-2 border-light-gray font-semibold relative w-full xl:w-95 text-left bg-blue-200 items-center text-lg md:text-xl`}
	&:focus:focus {
		box-shadow: none;
	}

	> svg {
		transition: all 0.3s linear;
		${tw`mr-4`}
	}

	> svg.up {
		transform: rotate(0);
	}

	> svg.down {
		transform: rotate(180deg);
	}
`
export const AccPanel = styled(AccordionPanel)`
	> div:nth-of-type(even) > p {
		${tw`bg-gray-200`}
	}
	> div:nth-of-type(even) > div {
		${tw`bg-gray-200`}
	}

	> div > div:first-of-type > span > button {
		${tw`ml-2 absolute`}
		top: 0;
		right: 0;
	}
`
export const AccordionButtonHolder = styled.div``
export const CheckMark = styled(Check)``
export const CustomizedToolTip = styled(Tooltip)`
	${tw`font-display bg-blue-500 text-white rounded py-2 px-4 border-0 ml-4 w-3/12 whitespace-normal text-base`}
`
export const AddToCartContainer = styled.div`
	${tw`flex flex-row mt-8 mb-16`}

	> div {
		${tw`border-0!`}
	}
`
export const AddToCartTitle = tw.div`w-4/12 lg:w-3/12 xl:w-1/5`
export const AddBook = tw.div`flex flex-col w-4/12 lg:w-3/12 items-center px-6 md:px-8 lg:px-12`
export const AddToCart = tw.button`font-display text-white w-full py-4 uppercase bg-yellow-500 hover:bg-yellow-400 rounded text-base mb-3`
export const Request = styled(Link)`
	${tw`font-display text-white w-full py-4 uppercase bg-yellow-500 hover:bg-yellow-400 rounded text-base mb-3 text-center`}
`
export const Book = styled(Link)`
	${tw`font-display text-white w-full py-4 uppercase bg-blue-500 hover:bg-blue-400 rounded text-base text-center`}
`
// tabdetails

// tabs
export const TabsContainer = tw.div`w-full`
export const TabsInner = tw.div`flex flex-row w-full mb-10`
export const Tab = styled.a`
	${tw`px-2 md:px-6 py-3 md:py-4 text-xs md:text-sm uppercase font-display font-semibold border-b border-gray-300`}

	&.active {
		${tw`border-t border-l border-r border-b-0 border-gray-300 text-blue-500`}
	}

	&:focus:focus {
		box-shadow: none;
	}
`
// tabs

// addproduct
export const AddProductBtn = styled.button`
	${tw`bg-yellow-600 hover:bg-yellow-500 uppercase text-white text-sm md:text-base font-display rounded px-2 md:px-4 ml-3 md:ml-8 flex flex-row items-center`}

	svg {
		${tw`mr-3 mb-1`}
	}

	&:focus:focus {
		box-shadow: none;
		outline: none;
	}
`

export const Overlay = styled<React.FC<DialogOverlayProps>>(DialogOverlay)`
	[data-reach-dialog-content] {
		${tw`p-0`}
	}
`
export const OverlayContent = styled<React.FC<DialogContentProps>>(DialogContent)`
	@media (max-width: 767px) {
		${tw`w-11/12`}
	}
	width: 500px;
`
export const OverlayHead = tw.div`flex flex-col w-full py-6 px-10 border-b border-gray-500`
export const OverlayTitle = tw.p`font-display text-xl mb-2 relative`
export const ActiveTab = tw.p`font-display text-sm text-blue-500`
export const CloseBtn = styled(XCircle)`
	${tw`absolute cursor-pointer`}
	top: 0;
	right: 0;
`
export const AddBtnHolder = tw.div`w-full flex items-center justify-center`
export const Add = styled.button`
	${tw`px-8 bg-yellow-600 hover:bg-yellow-500 py-2 uppercase text-white font-display rounded mb-4 text-xs flex flex-row items-center`}
`

export const SelectionContainer = styled.div`
	${tw`w-full flex flex-col py-6 px-10`}

	[data-reach-listbox-input] {
		${tw`w-full`}
	}
	[data-reach-listbox-button] {
		${tw`w-full py-2 px-2 font-display text-sm font-semibold rounded`}

		&:focus {
			outline: #58c8df 5px auto;
		}
	}
	> div:not(:last-of-type) {
		${tw`mb-1`}
	}
`
export const Popover = styled(ListboxPopover)`
	${tw`font-display text-sm`}
	z-index: 100;
`

export const ModelImageContainer = styled.div`
	max-height: 150px;
	${tw`flex items-center justify-center h-screen mb-4`}
	&:hover {
		img {
			opacity: 0.875;
		}
	}
`
export const ModelImage = styled.picture`
	${tw`h-full`}

	img {
		max-height: 150px;
	}
`
export const PlusAdd = styled(Plus)`
	${tw`-mt-0.5 mr-2`}
`
// addproduct
